import { log } from '@/logger/logger';

const logger = log.getLogger('figmaEmbedToken');

export type FigmaEmbedPermission = 'view' | 'edit';

export interface FigmaEmbedTokenPayload {
  sub: string;
  exp: number;
  iat?: number;
  permission?: FigmaEmbedPermission;
  recipe_id?: string;
}

export function decodeFigmaEmbedToken(token: string): FigmaEmbedTokenPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;

    // Base64url → base64, then re-pad to a multiple of 4.
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');

    // `atob` produces a binary string (one char per byte). Route it through a byte array and
    // TextDecoder so any future multi-byte UTF-8 claim (accented Latin, CJK, Arabic, etc.)
    // round-trips correctly. Without this, non-ASCII input comes back as mojibake
    // (e.g., "日本語" → "æ¥æ¬èª"). The current token schema is ASCII-only, but this is a
    // cheap guard against silent corruption if a string claim gets added later.
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const json = new TextDecoder('utf-8').decode(bytes);

    const payload = JSON.parse(json) as FigmaEmbedTokenPayload;
    if (typeof payload?.sub !== 'string' || typeof payload?.exp !== 'number') {
      return null;
    }
    return payload;
  } catch (error) {
    logger.error('Failed to decode Figma embed token payload', error);
    return null;
  }
}
